import { useState } from "react";
import { Alert, Button, Form } from "react-bootstrap";
import { getDatabase, ref, set } from "firebase/database";
import app from "../firebase";
import $ from "jquery";
import "./FAB.css";

export default function FAB(second) {
  const [isContact, setContact] = useState(false);
  const [userData, setUserData] = useState({});
  const [isAlert, setAlert] = useState(false);
  const [alertType, setAlertType] = useState("");
  const [alertMessage, setAlertMessage] = useState("");

  let handleOpen = () => {
    if (isContact) {
      setContact(false);
    } else {
      setContact(true);
    }
  };

  $(document).ready(function () {
    if (isContact) {
      $(".form-fab form").css("bottom", "5rem").show(300);
      $(".form-fab form").show(300);
    } else {
      $(".form-fab form").hide(300);
    }
  });

  let submit = async (e) => {
    e.preventDefault();
    const db = getDatabase(app);
    set(
      ref(
        db,
        "queries/" +
          userData.email.split(".")[0] +
          Math.floor(Math.random() * 1000)
      ),
      {
        name: userData.name,
        clientMail: userData.email,
        clientMobile: userData.mobile,
        clientMsg: userData.description,
        date: new Date(),
      }
    )
      .then(() => {
        setAlert(true);
        setAlertType("success");
        setAlertMessage(
          "Your request has been raised successfully, if I didn't respond to your query within 24 hrs, please mail me at zdkhan0786@gmail.com"
        );
      })
      .catch(console.error);
  };

  return (
    <>
      <button className="btn btn-dark" id="closed" onClick={handleOpen}>
        {isContact ? (
          <i className="fa-solid fa-xmark"></i>
        ) : (
          <i className="fa-solid fa-comment"></i>
        )}
      </button>
      <div className="form-fab">
        <Form onSubmit={submit} className="bg-dark text-light">
          <h4 className="mb-3">Contact me</h4>
          {isAlert ? (
            <Alert variant={alertType} key={alertType}>
              {alertMessage}
            </Alert>
          ) : (
            <>
              <Form.Group className="mb-3" controlId="name">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your name"
                  onChange={(e) =>
                    setUserData({ ...userData, name: e.target.value })
                  }
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="email">
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your email address"
                  onChange={(e) =>
                    setUserData({ ...userData, email: e.target.value })
                  }
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="mobile">
                <Form.Label>Mobile</Form.Label>
                <Form.Control
                  type="number"
                  min="1000000000"
                  minLength="10"
                  placeholder="Enter your mobile number"
                  onChange={(e) =>
                    setUserData({ ...userData, mobile: e.target.value })
                  }
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="description">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  placeholder="Enter reason for your contact"
                  onChange={(e) =>
                    setUserData({ ...userData, description: e.target.value })
                  }
                  required
                />
              </Form.Group>

              <Button variant="danger" type="submit">
                Submit
              </Button>
            </>
          )}
        </Form>
      </div>
    </>
  );
}
